import { makeApi } from "@zodios/core";
import { z } from "zod";

import { appointmentTypeDtoSchema } from "@/types/backoffice/dto/appointment/appointment-type-dto.ts";

export const backofficeAppointmentApi = makeApi([
  {
    method: "get",
    path: "/types/site/:siteId",
    response: z.array(appointmentTypeDtoSchema),
    alias: "findAppointmentTypesBySiteId",
  },
]);
